import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=2205a7f4"
import script from "./Cost.vue?vue&type=script&lang=js"
export * from "./Cost.vue?vue&type=script&lang=js"
import style0 from "./Cost.vue?vue&type=style&index=0&id=2205a7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports